import dayjs from "dayjs";
import { useState, useCallback, useEffect, useRef } from "react";

export interface FiltersState {
  status: Record<string, boolean>;
  dateFrom: string | null;
  dateTo: string | null;
  activeStatuses: string[];
  activeTable: string | null;
  rowCount: number;
}

export const useTaskInfoFilters = () => {
  const today = dayjs();
  const dateFrom = today.startOf("day");
  const dateTo = today;
  const updateIntervalRef = useRef<number | null>(null);
  const [isAutoUpdating, setIsAutoUpdating] = useState(false);

  const [filters, setFilters] = useState<FiltersState>({
    status: {
      requested: false,
      processing: false,
      completed: false,
      cancelled: false,
      failed: false,
      notImplemented: false,
    },
    dateFrom: dateFrom.toISOString(),
    dateTo: dateTo.toISOString(),
    activeStatuses: [],
    activeTable: null,
    rowCount: 100,
  });

  // Update dateTo to current time every minute to keep it moving forward
  useEffect(() => {
    updateIntervalRef.current = window.setInterval(() => {
      setIsAutoUpdating(true);
      setFilters((prev) => ({
        ...prev,
        dateTo: dayjs().toISOString(),
      }));

      // Hide the indicator after 3 seconds
      setTimeout(() => {
        setIsAutoUpdating(false);
      }, 3000);
    }, 60000); // Update every minute

    return () => {
      if (updateIntervalRef.current) {
        window.clearInterval(updateIntervalRef.current);
      }
    };
  }, []);

  const handleFilterChange = (key: string, value: unknown) => {
    if (Object.keys(filters.status).includes(key)) {
      setFilters((prev) => ({
        ...prev,
        status: {
          ...prev.status,
          [key]: Boolean(value),
        },
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const updateDateToNow = useCallback(() => {
    setFilters((prev) => ({
      ...prev,
      dateTo: dayjs().toISOString(),
    }));
  }, []);

  return {
    filters,
    handleFilterChange,
    updateDateToNow,
    isAutoUpdating,
  };
};
